import {
  Service1,
  Service1Description,
  Service2,
  Service2Description,
  Service3,
  Service3Description,
  Service4,
  Service4Description,
  Service5,
  Service5Description,
  Service6,
  Service6Description,
  ServicesDescription,
} from "../../constants";

const Services: React.FC<{}> = () => {
  return (
    <div>
      {" "}
      <section id="services" className="section-bg">
        <div className="container">
          <header className="section-header wow fadeInUp">
            <h3>Services</h3>
            <p>{ServicesDescription}</p>
          </header>

          <div className="row" style={{ color: "#00008B" }}>
            <div
              className="col-lg-4 col-md-6 box wow bounceInUp"
              data-wow-duration="1.4s"
            >
              <div className="icon">
                <i className="ion-ios-analytics-outline"></i>
              </div>
              <h4 className="title">{Service1}</h4>
              <p className="description">{Service1Description}</p>
            </div>
            <div
              className="col-lg-4 col-md-6 box wow bounceInUp"
              data-wow-duration="1.4s"
            >
              <div className="icon">
                <i className="ion-ios-bookmarks-outline"></i>
              </div>
              <h4 className="title">{Service2}</h4>
              <p className="description">{Service2Description}</p>
            </div>
            <div
              className="col-lg-4 col-md-6 box wow bounceInUp"
              data-wow-duration="1.4s"
            >
              <div className="icon">
                <i className="ion-ios-paper-outline"></i>
              </div>
              <h4 className="title">{Service3}</h4>
              <p className="description">{Service3Description}</p>
            </div>
            <div
              className="col-lg-4 col-md-6 box wow bounceInUp"
              data-wow-delay="0.1s"
              data-wow-duration="1.4s"
            >
              <div className="icon">
                <i className="ion-ios-speedometer-outline"></i>
              </div>
              <h4 className="title">{Service4}</h4>
              <p className="description">{Service4Description}</p>
            </div>
            <div
              className="col-lg-4 col-md-6 box wow bounceInUp"
              data-wow-delay="0.1s"
              data-wow-duration="1.4s"
            >
              <div className="icon">
                <i className="ion-ios-barcode-outline"></i>
              </div>
              <h4 className="title">{Service5}</h4>
              <p className="description">{Service5Description}</p>
            </div>
            <div
              className="col-lg-4 col-md-6 box wow bounceInUp"
              data-wow-delay="0.1s"
              data-wow-duration="1.4s"
            >
              <div className="icon">
                <i className="ion-ios-people-outline"></i>
              </div>
              <h4 className="title">{Service6}</h4>
              <p className="description">{Service6Description}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
